var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 3.99998C10.6957 3.99998 13.1894 5.52465 14.5787 7.99998C14.1074 8.83998 13.5064 9.56731 12.8157 10.1656L13.761 11.111C14.6317 10.339 15.366 9.39865 15.9137 8.33231C16.0204 8.12498 16.0204 7.87498 15.9137 7.66765C14.383 4.68831 11.414 2.66665 8.00004 2.66665C7.1867 2.66665 6.39937 2.78465 5.65004 2.99998L6.76237 4.11231C7.16804 4.04098 7.58104 3.99998 8.00004 3.99998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.13804 0.195312L0.19537 1.13798L3.20137 4.14398C1.89704 5.01998 0.816036 6.23931 0.0767031 7.68698C-0.0229635 7.88231 -0.0229635 8.11765 0.0767031 8.31298C1.60404 11.303 4.5787 13.3333 8.00004 13.3333C9.27837 13.3333 10.4944 13.0496 11.596 12.5386L14.862 15.8046L15.8047 14.862L1.13804 0.195312ZM8.00004 12C5.30304 12 2.8107 10.4756 1.42137 7.99998C2.1047 6.78265 3.05537 5.79698 4.16504 5.10765L6.1967 7.13931C6.07204 7.40031 6.00004 7.69131 6.00004 7.99998C6.00004 9.10465 6.89537 9.99998 8.00004 9.99998C8.3087 9.99998 8.5997 9.92798 8.8607 9.80331L10.5747 11.5173C9.7597 11.83 8.8917 12 8.00004 12Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePassword);
export default __webpack_public_path__ + "static/media/hide_password.cae5f7b84b889886246bb19a8a13d5fc.svg";
export { ForwardRef as ReactComponent };